import { PaymentTiers } from './PaymentTiers';

import { Typography } from '~/components/core';
import { useCanAccessSecuritySettings } from '~/hooks';

const SubscriptionSettings = () => {
  const { userCanManageOrganization } = useCanAccessSecuritySettings();

  return (
    <div
      className="flex flex-col gap-6"
      data-testid="subscription-settings-container"
    >
      <PaymentTiers userCanManageOrganization={userCanManageOrganization} />
      {!userCanManageOrganization && (
        <div
          className="flex w-full justify-center"
          data-testid="contact-admin-message"
        >
          <Typography italic>
            To upgrade, contact your organization's administrator.
          </Typography>
        </div>
      )}
    </div>
  );
};
export default SubscriptionSettings;
